import { SkinTypeTest } from './SkinTypeTest'

export default SkinTypeTest
